// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".privilege-page .table-page-search-wrapper[data-v-b26e8762] {\n  margin-bottom: 16px;\n}\n.privilege-page .permission-label[data-v-b26e8762] {\n  margin-left: 8px;\n}\n", ""]);
// Exports
module.exports = exports;
